import { SVGProps } from 'react';

const CheckCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='#9E9E9E'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9999 21.5999C14.546 21.5999 16.9878 20.5885 18.7881 18.7881C20.5885 16.9878 21.5999 14.546 21.5999 11.9999C21.5999 9.45382 20.5885 7.01203 18.7881 5.21168C16.9878 3.41133 14.546 2.3999 11.9999 2.3999C9.45382 2.3999 7.01203 3.41133 5.21168 5.21168C3.41133 7.01203 2.3999 9.45382 2.3999 11.9999C2.3999 14.546 3.41133 16.9878 5.21168 18.7881C7.01203 20.5885 9.45382 21.5999 11.9999 21.5999V21.5999ZM16.4483 10.4483C16.6669 10.222 16.7878 9.91886 16.7851 9.60422C16.7824 9.28959 16.6562 8.98861 16.4337 8.76612C16.2112 8.54363 15.9102 8.41743 15.5956 8.41469C15.2809 8.41196 14.9778 8.53291 14.7515 8.7515L10.7999 12.7031L9.2483 11.1515C9.02198 10.9329 8.71886 10.812 8.40422 10.8147C8.08958 10.8174 7.78861 10.9436 7.56612 11.1661C7.34363 11.3886 7.21743 11.6896 7.21469 12.0042C7.21196 12.3189 7.33291 12.622 7.5515 12.8483L9.9515 15.2483C10.1765 15.4733 10.4817 15.5996 10.7999 15.5996C11.1181 15.5996 11.4233 15.4733 11.6483 15.2483L16.4483 10.4483V10.4483Z'
      />
    </svg>
  );
};

export default CheckCircle;
